/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export class UploadPanelDirectiveController {

        public static $inject : string[ ] = [ '$scope', 'Upload' ];

        public cancelUploadFileWatcher  : any;
        public fileToUpload             : any;

        constructor(
            private $scope          : any,
            private UploadService   : any
        ) {

            var that = this;

            // Dragging a file to the target zone, or browsing for it, fires off this watcher
            // and the file gets POSTed to the backend.
            //
            this.cancelUploadFileWatcher = that.$scope.$watch(
                ( ) => {
                    return that.fileToUpload;
                },
                ( file: any ) => {
                    if (file !== undefined && that.$scope.onUploadFileChosen) {
                        file.upload = that.UploadService.upload;
                        that.$scope.onUploadFileChosen.call (
                            that.$scope.onUploadFileChosenScope, file
                        );
                    }
                }
            );
        }

        public clickUploadButton () : void {
            angular.element('.upload-file').click();
        }
    }

    export class UploadPanelDirective implements ng.IDirective {

        public restrict     : string    = 'E';
        public controller   : any       = 'UploadPanelDirectiveController';
        public controllerAs : string    = 'UP';
        public scope        : Object    = {
            onUploadFileChosen      : '=',
            onUploadFileChosenScope : '=?',
            uploadButtonText        : '@?'
        };
        public templateUrl  : string    = '/components/upload/panel-directive.html';
    }

    getDealerwareWebComponentsModule().controller(
        'UploadPanelDirectiveController', UploadPanelDirectiveController
    );

    getDealerwareWebComponentsModule().directive(
        'dealerwareUploadPanel', ( ) => new UploadPanelDirective()
    );
}
